import CustomText from "@components/CustomText";
import color from "@constants/color";
import React from "react";
import Cross from "@assets/svg/CrossRed";
import {
  Modal,
  TouchableNativeFeedback,
  View,
  useWindowDimensions,
  StyleSheet,
  Image,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import {
  SafeAreaProvider,
  useSafeAreaInsets,
} from "react-native-safe-area-context";

const InfoTooltipModalContent = (props) => {
  const {
    setVisible,
    data = {
      title: "",
      list: [],
    },
  } = props;

  const { height } = useWindowDimensions();
  // Insets from the SafeAreaProvider nested inside the Modal (wrapper below), so
  // the value reflects the modal's own translucent window. The root provider
  // reports bottom: 0 while a navigationBarTranslucent modal is open, which
  // clipped the last list rows behind the soft-nav bar.
  const insets = useSafeAreaInsets();

  return (
    <View style={styles.modal}>
      <TouchableNativeFeedback
        testID="cancel"
        onPress={() => setVisible(false)}
      >
        <View style={styles.cancelArea} />
      </TouchableNativeFeedback>

      <View
        style={[
          styles.modalContainer,
          { minHeight: height / 4, maxHeight: (height * 3) / 4 },
          { paddingBottom: insets.bottom + 16 },
        ]}
      >
        <View style={styles.headerContainer}>
          <CustomText variant="title_20" style={styles.textColor}>
            {data?.title}
          </CustomText>
          <TouchableNativeFeedback
            testID="Cross"
            onPress={() => setVisible(false)}
          >
            <Cross
              width={24}
              height={24}
              bgColor="rgba(0,0,0,0.1)"
              color="black"
            />
          </TouchableNativeFeedback>
        </View>
        <ScrollView style={styles.scrollContainer}>
          {data?.list &&
            Array.isArray(data?.list) &&
            data?.list.map((v, index) =>
              typeof v === "string" ? (
                <CustomText
                  key={v}
                  variant="body_text_3"
                  style={styles.textColor}
                >
                  {v}
                </CustomText>
              ) : (
                <View
                  key={v?.shipment_id ?? v?.name ?? index}
                  style={styles.productRow}
                >
                  <Image
                    source={{ uri: v?.image }}
                    style={styles.productImage}
                    resizeMode="contain"
                  />
                  <View style={styles.productDetails}>
                    <CustomText
                      variant="body_text_4"
                      style={styles.productName}
                    >
                      {v?.name || ""}
                    </CustomText>
                    <View style={styles.priceRow}>
                      <CustomText
                        variant="body_text_3"
                        style={styles.quantity}
                      >{`Qty: ${v?.quantity || ""}`}</CustomText>
                    </View>
                  </View>
                </View>
              ),
            )}
        </ScrollView>
      </View>
    </View>
  );
};

const InfoTooltipModal = (props) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={props.visible}
      statusBarTranslucent
      navigationBarTranslucent
    >
      {/* Nested provider measures the modal's own translucent window so
          useSafeAreaInsets() reports the real nav-bar inset inside the Modal. */}
      <SafeAreaProvider>
        <InfoTooltipModalContent {...props} />
      </SafeAreaProvider>
    </Modal>
  );
};

const styles = StyleSheet.create({
  cancelArea: {
    backgroundColor: color.trans_209_248,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 16,
    flex: 1,
  },
  modal: {
    backgroundColor: color.modalBackground,
    flex: 1,
  },
  modalContainer: {
    backgroundColor: color.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 16,
  },
  scrollContainer: { marginVertical: 16 },
  headerContainer: { flexDirection: "row", justifyContent: "space-between" },
  textColor: { color: color.mediumBlack },
  productRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  productImage: {
    width: 60,
    height: 60,
    borderRadius: 8,
    marginRight: 12,
  },
  productDetails: {
    flex: 1,
  },
  productName: {
    fontSize: 16,
    fontWeight: "600",
    color: color.mediumBlack,
    marginBottom: 4,
  },
  priceRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  quantity: {
    color: color.black06,
    fontSize: 16,
    fontWeight: "400",
  },
});

export default InfoTooltipModal;
